import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { of, throwError } from "rxjs";
import { catchError, map, mergeMap } from "rxjs/operators";
import { ImpactedKpis, KpiPayloadFormat } from "../models/insight-configuration.model";


@Injectable()

export class InsightConfigurationService {
  public API_URL = '';

  constructor(
    private httpClient: HttpClient,
  ) {}

  public getHeaders() {
    let header = new HttpHeaders();
    return header;
  }

  public getJwtToken(userName:any) {
    let RequestBody = {
      user: userName
    };

    return this.httpClient.post(`${this.API_URL}/api/iaconfig/ewb/apitoken`, RequestBody).pipe(
      map(data => {
            let token;
            if(data['ewb_api_token']) {
              token = data['ewb_api_token']
            }
             localStorage.setItem('jwttoken', token);
             return token;
          }),
          catchError(() => {
            return of([])
          })
    )
  }
public getModels()
{
let  userName= localStorage.getItem('userName');
  let RequestBody = {
      user: userName
    };
       return this.httpClient.post(`${this.API_URL}/api/iaconfig/ewb/listpackages`, RequestBody).pipe(
      map(data => data['packages']),
      catchError(() => of([]))
    )
}

public getVersionList(id:number)
{
  let  userName= localStorage.getItem('userName');
  let RequestBody = {
      user: userName,
      package_id : id
    };
     return this.httpClient.post(`${this.API_URL}/api/iaconfig/ewb/listpackageversions`, RequestBody).pipe(
      map(data => data['package_versions']),
      catchError(() => of([]))
    )
}
public getInputIdList(package_version_id:number)
{
  let  userName= localStorage.getItem('userName');
  let RequestBody = {
      user: userName,
      package_version_id : package_version_id
    };
    return this.httpClient.post(`${this.API_URL}/api/iaconfig/ewb/packagedetails`,  RequestBody).pipe(
      map(data => data['package_detail']['inputs'][0]['id']),
      catchError(() => of([]))
    )
}

  public getConfigurationTypes() {
    this.API_URL = window['environmentVariableConfig']['configUIApiUrl'];
    return this.httpClient.get(`${this.API_URL}/api/iaconfig/insights/configurations/types`)
    .pipe(
      map(data => data['configurationTypes']),
      catchError(() => of([]))
    )
  }
  public getKpiList(plantId: string) {
    this.API_URL = window['environmentVariableConfig']['configUIApiUrl'];
    let params =  new HttpParams()

    if(plantId && plantId !== '') {
      params = params.set('asset', plantId)
    }

    return this.httpClient.get<any[]>(`${this.API_URL}/api/smartkpi/listkpi`,{ params: params })
    .pipe(
      map(data => data),
      catchError(() => of([]))
    )
  }

  public getKpiValidationList(plantId: string) {
    this.API_URL = window['environmentVariableConfig']['configUIApiUrl'];
    let params =  new HttpParams()

    if(plantId && plantId !== '') {
      params = params.set('plantId', plantId)
    }

    return this.httpClient.get<any[]>(`${this.API_URL}/api/iaconfig/insights/configurations/kpis`,{ params: params })
    .pipe(
      map(data => data['kpiList']),
      catchError(() => of([]))
    )
  }

  public submitKpiConfiguration(category: any,selectedKpis: KpiPayloadFormat[]) {
    this.API_URL = window['environmentVariableConfig']['configUIApiUrl'];
    let kpiList = this.prepareKpiBody(category, selectedKpis);
    let requestBody = {
      configurations: kpiList
    };
    return this.httpClient.post(`${this.API_URL}/api/iaconfig/insights/configurations`, requestBody)
    .pipe(
      map((data) => data),
      catchError(() => of(null))
    )
  }

  public getConfigurationList(plantId?: string) {
    let params = new HttpParams();

    if(plantId && plantId !== '') {
      params = params.set('plantId', plantId)
    }

    this.API_URL = window['environmentVariableConfig']['configUIApiUrl'];
    return this.httpClient.get(`${this.API_URL}/api/iaconfig/insights/configurations`, {params: params})
    .pipe(
      map(data => data['insightsConfigurationsList']),
      catchError(() => of([]))
    )
  }

  public getDepartments() {
    this.API_URL = window['environmentVariableConfig']['configUIApiUrl'];
    return this.httpClient.get(`${this.API_URL}/api/people-management/departments`)
    .pipe(
      map(data => data['Departments']),
      catchError(() => of([]))
    )
  }

  public getAlgorithmList(configId: string) {
    this.API_URL = window['environmentVariableConfig']['configUIApiUrl'];
    return this.httpClient.get(`${this.API_URL}/api/iaconfig/insights/configurations/algorithm/models/${configId}`)
    .pipe(
      map(data => data['algorithmList']),
      catchError(() => of([]))
    )
  }


  public getRoleIds(plantId: string) {
    this.API_URL = window['environmentVariableConfig']['configUIApiUrl'];
    return this.httpClient.get(`${this.API_URL}/api/operation-heirarchy/plant/${plantId}/Roles`)
    .pipe(
      map(data => data['Roles']),
      catchError(() => of([]))
    )
  }

  public getRolesByPlant(roleIdList: any[]) {
    this.API_URL = window['environmentVariableConfig']['configUIApiUrl'];
    let params = new HttpParams();
    params = params.set('ids', JSON.stringify(roleIdList))

    return this.httpClient.get(`${this.API_URL}/api/people-management/roles/byIds`, {params: params})
    .pipe(
      map(data => data['Roles']),
      catchError(() => of([]))
    )
  }

  public getRolesByDepartment(departmentId: string) {
    this.API_URL = window['environmentVariableConfig']['configUIApiUrl'];
    let requestBody = {
      DepartmentIds: [departmentId]
    }
    return this.httpClient.post(`${this.API_URL}/api/people-management/roles/byDepartment`, requestBody)
    .pipe(
      map(data => data['Roles']),
      catchError(() => of([]))
    )
  }

  public getThemes(configId: string) {
    this.API_URL = window['environmentVariableConfig']['configUIApiUrl'];
    return this.httpClient.get(`${this.API_URL}/api/iaconfig/insights/configurations/themes/${configId}`, { headers: this.getHeaders()})
    .pipe(
      map(data => data['themeList']),
      catchError(() => of([]))
    )
  }

  public getSubTypes(themeId: string, configId: string) {
    this.API_URL = window['environmentVariableConfig']['configUIApiUrl'];
    return this.httpClient.get(`${this.API_URL}/api/iaconfig/insights/configurations/theme/${themeId}/subtypes/${configId}`, { headers: this.getHeaders() })
    .pipe(
      map(data => data['subTypeList']),
      catchError(() => of([]))
      )
  }

  public getAssetList(modelId: string, plantId: string, categoryId: string) {

    this.API_URL = window['environmentVariableConfig']['configUIApiUrl'];
    let params =  new HttpParams();

    if(modelId && modelId !== '') {
      params = params.set('modelId', modelId)
    }

    if(plantId && plantId !== '') {
      params = params.set('plantId', plantId)
    }

    return this.httpClient.get(`${this.API_URL}/api/iaconfig/insights/configurations/assets/${categoryId}`,{ params: params })
    .pipe(
      map(data => data['assetList']),
      catchError(() => of([]))
    )

  }

  public submitPredictiveFailureConfiguration(plant: any, category: any, selectedAlgorithm: any, selectedAssets:any[], configurationDetails:any, selectedKpis: ImpactedKpis[], timeseries: any[]) {
    this.API_URL = window['environmentVariableConfig']['configUIApiUrl'];
    const requestBody = this.preparePredictiveBody(plant, category, selectedAlgorithm, selectedAssets, configurationDetails, selectedKpis, timeseries);

    return this.httpClient.post(`${this.API_URL}/api/iaconfig/insights/configurations`, requestBody)
    .pipe(
      map((data) => data),
      catchError(() => of(null))
    )
  }

  public submitEWBConfiguration(plant: any,user_id, package_version_id, package_exec_id,inputs_id, category: any, selectedAlgorithm: any, selectedAssets:any[], configurationDetails:any, selectedKpis: ImpactedKpis[], timeseries: any[]) {
    this.API_URL = window['environmentVariableConfig']['configUIApiUrl'];
    const requestBody = this.prepareEWBBody(plant,user_id, package_version_id, package_exec_id,inputs_id, category, selectedAlgorithm, selectedAssets, configurationDetails, selectedKpis, timeseries);

    return this.httpClient.post(`${this.API_URL}/api/iaconfig/insights/configurations`, requestBody)
    .pipe(
      map((data) => data),
      catchError(() => of(null))
    )
  }

  public getConfigurationDetails(configurationId: string) {
    this.API_URL = window['environmentVariableConfig']['configUIApiUrl'];

    return this.httpClient.get(`${this.API_URL}/api/iaconfig/insights/configurations/${configurationId}`)
    .pipe(
      map((data)=> data)
    )
  }

  public updatePredictiveFailureConfiguration(configurationId: string, updateDetails : any) {
    this.API_URL = window['environmentVariableConfig']['configUIApiUrl'];
    const requestBody = this.preparePredictiveBody(updateDetails.plant, updateDetails.category, updateDetails.selectedAlgorithm, updateDetails.selectedAssets, updateDetails.configurationDetails, updateDetails.selectedKpis, updateDetails.timeseries);
    return this.httpClient.put(`${this.API_URL}/api/iaconfig/insights/configurations/${configurationId}`, requestBody)
    .pipe(
      map(data => data),
      catchError(() => of(null))
    )
  }

  public updateEWBConfiguration(configurationId: string,updateDetails : any) {
    this.API_URL = window['environmentVariableConfig']['configUIApiUrl'];
    const requestBody = this.prepareEWBBody(updateDetails.plant,updateDetails.user_id, updateDetails.package_version_id, updateDetails.package_exec_id,updateDetails.inputs_id, updateDetails.category, updateDetails.selectedAlgorithm, updateDetails.selectedAssets, updateDetails.configurationDetails, updateDetails.selectedKpis, updateDetails.timeseries);
    return this.httpClient.put(`${this.API_URL}/api/iaconfig/insights/configurations/${configurationId}`, requestBody)
    .pipe(
      map(data => data),
      catchError(() => of(null))
    )
  }
  public saveEditKpiConfiguration(configurationId:string, category: any, editKPI: any) {
    this.API_URL = window['environmentVariableConfig']['configUIApiUrl'];
    let requestBody = {
      configurations: [editKPI]
    };
    return this.httpClient.put(`${this.API_URL}/api/iaconfig/insights/configurations/${configurationId}`, requestBody)
    .pipe(
      map((data) => data)
    )
  }

  public getUserRoles() {
    this.API_URL= window['environmentVariableConfig']['configUIApiUrl'];

    return this.httpClient.get<any>(`${this.API_URL}/api/people-management/users/bytoken`, {headers: this.getHeaders()}).pipe(
      map(data => {
        if(data){
          localStorage.setItem('userName',data?.Users[0].Email);
        }
        if(data?.Users[0].UserId) {
          return data.Users[0].UserId
        } else {
          throwError(null)
        }
      }),
      mergeMap((userId) => {
        let requestBody = {
          UserIds: [userId]
        }
        return this.httpClient.post<any>(`${this.API_URL}/api/people-management/roles/byUser`, requestBody, {headers: this.getHeaders()}).pipe(
          map(data => {
            let roles = [];
            if(data && data.Roles?.length > 0) {
              roles = data.Roles.map(role => role.RoleName);
            }
            return roles;
          }),
          catchError(() => {
            return of([])
          })
        )
      })
    )
  }

  public getPlantList() {
    this.API_URL = window['environmentVariableConfig']['configUIApiUrl'];
    return this.httpClient.get(`${this.API_URL}/api/oh-module/plantlist`)
    .pipe(
      map(data => data['plantlist']),
      catchError(() => of([]))
    )
  }

  public deleteConfiguration(configurationId: string) {
    this.API_URL = window['environmentVariableConfig']['configUIApiUrl'];

    return this.httpClient.delete(`${this.API_URL}/api/iaconfig/insights/configurations/${configurationId}`)
  }

  public getTimeseries() {
    let timeseries = [
      {
        "key_vibration_1": "vibration_1"
      },
      {
        "key_vibration_2": "vibration_2"
      },
      {
        "key_pressure_1": "pressure_1"
      },
      {
        "key_pressure_2": "pressure_2"
      },
      {
        "key_pressure_3": "pressure_3"
      },
      {
        "key_temp_1": "temp_1"
      },
      {
        "key_temp_2": "temp_2"
      }
    ]

    return timeseries;
  }

    public getEWBtimeSeries()
    {
      let timeseries=[
        {
            "key_suction_flow": "suction_flow"
        },
        {
            "key_suction_pressure": "suction_pressure"
        },
        {
            "key_annbar_temperature": "annbar_temperature"
        },
        {
            "key_delta_pressure": "delta_pressure"
        },
        {
            "key_suction_temperature": "suction_temperature"
        },
        {
            "key_discharge_temperature_cyl1": "discharge_temperature_cyl1"
        },
        {
            "key_discharge_temperature_cyl2": "discharge_temperature_cyl2"
        },
        {
            "key_discharge_pressure": "discharge_pressure"
        },
        {
            "key_operating_state": "operating_state"
        }
     ]
     return timeseries;
    }
  

  public prepareKpiBody (category: any,selectedKpis: any[]) {
    let trigger = 'event';
   const id="bbf4a58cf02711ef8fe02a6efc89f829"
    const kpiBody =  selectedKpis.map((kpi) => {
      kpi.configurationCategory = category.viewId;
      kpi.category = category.category;
      kpi.template = category.template;
      kpi.type = category.type;
      kpi.subtype = category?.subtype;
      kpi.theme = {
        label:  category?.theme,
      };
      kpi.role = {
        roleId: kpi.role?.roleId,
        roleName: kpi.role?.roleName
      };
      kpi.department = {
        departmentId: kpi.department?.departmentId,
        departmentName: kpi.department?.departmentName
      };
      kpi.actionIn = {
        value: kpi.actionIn?.value,
        unit: kpi.actionIn?.unit
      };
      kpi.plant = {
        plantId: kpi.plant?.plantId,
        plantName: kpi.plant?.plantName
      };
      kpi.trigger = trigger;
      kpi.insightCategoryParameters = {
        assetHierarchyLevel: kpi.assetHierarchyLevel,
        configId: kpi.configId,
        name: kpi.name,
        uid: kpi.uid,
        frequency: kpi.frequency,
        configured: kpi.configured,
      };

      delete kpi.assetHierarchyLevel
      delete kpi.configId
      delete kpi.configured
      delete kpi.frequency
      delete kpi.name
      delete kpi.uid
      delete kpi.selected
      return kpi;
    })
  
    return kpiBody;
  
  
  }

  public preparePredictiveBody(plant: any, category:any, selectedAlgorithm: any, selectedAssets:any[], configurationDetails:any, selectedKpis: ImpactedKpis[], timeseries: any[]) {
    let trigger = 'scheduled';

    const impactedKpis = selectedKpis?.map((kpi) => {
      kpi.department =
        {
          departmentId: kpi.department.departmentId,
          departmentName: kpi.department.departmentName
        }
      kpi.schedule = kpi.frequency
      kpi.role = {
        roleId: kpi.role.roleId,
        roleName: kpi.role.roleName
      }

      return kpi
    })

    let predictiveBody = {
      configurations: [
        {
          configurationCategory: category?.viewId,
          category: category?.category,
          template: category?.template,
          type: category?.type,
          subtype: configurationDetails?.subtype,
          trigger: trigger,
          theme: {
            id: configurationDetails?.theme?.id,
            label: configurationDetails?.theme?.label
          },
          role: {
            roleId: configurationDetails?.role?.roleId,
            roleName: configurationDetails?.role?.roleName
          },
          department: {
            departmentId: configurationDetails?.department?.departmentId,
            departmentName: configurationDetails?.department?.departmentName
          },
          actionIn: {
            value: configurationDetails?.actionIn?.value,
            unit: configurationDetails?.actionIn?.unit
          },
          plant: {
            plantId: plant?.plantId,
            plantName: plant?.plantName
          },
          insightCategoryParameters: {
            description: configurationDetails?.description,
            priority:configurationDetails?.priority,
            algorithm: {
              modelId: selectedAlgorithm?.modelId,
              modelName: selectedAlgorithm?.modelName
            },
            //frequency
            schedule: {
              value: configurationDetails?.frequency?.value,
              unit: configurationDetails?.frequency?.unit
            },
            //threshold
            conditions: [{
              value: configurationDetails?.threshold?.value,
              condition: configurationDetails?.threshold?.condition,
              config: {
                type: configurationDetails?.threshold?.config?.type,
                min: configurationDetails?.threshold?.config?.min,
                max: configurationDetails?.threshold?.config?.max
              }
            }],
            impactedKpis:impactedKpis,
            assetList: selectedAssets,
          },
          modelParameters: timeseries,
        }
      ]
  }

  return predictiveBody;
  }

  public prepareEWBBody(plant: any, user_id:string, package_version_id:number, package_exec_id:any,inputs_id:string,category:any, selectedAlgorithm: any, selectedAssets:any[], configurationDetails:any, selectedKpis: ImpactedKpis[], timeseries: any[]) {
    let trigger = 'scheduled';
  
    const impactedKpis = selectedKpis?.map((kpi) => {
      kpi.department =
        {
          departmentId: kpi.department.departmentId,
          departmentName: kpi.department.departmentName
        }
      kpi.schedule = kpi.frequency
      kpi.role = {
        roleId: kpi.role.roleId,
        roleName: kpi.role.roleName
      }

      return kpi
    })


    let ewbBody = {
      configurations: [
        {
          configurationCategory: category?.viewId,
          category: category?.category,
          template: category?.template,
          type: category?.type,
          subtype: configurationDetails?.subtype,
          trigger: trigger,
          theme: {
            id: configurationDetails?.theme?.id,
            label: configurationDetails?.theme?.label
          },
          role: {
            roleId: configurationDetails?.role?.roleId,
            roleName: configurationDetails?.role?.roleName
          },
          department: {
            departmentId: configurationDetails?.department?.departmentId,
            departmentName: configurationDetails?.department?.departmentName
          },
          actionIn: {
            value: configurationDetails?.actionIn?.value,
            unit: configurationDetails?.actionIn?.unit
          },
          plant: {
            plantId: plant?.plantId,
            plantName: plant?.plantName
          },
          insightCategoryParameters: {
            description: configurationDetails?.description,
            priority:configurationDetails?.priority,
              package_version_id: package_version_id,
              inputs_id: inputs_id,
              package_exec_id:package_exec_id,
              user_id : user_id,
            algorithm: {
              modelId: selectedAlgorithm[0]?.modelId ,
              modelName: selectedAlgorithm[0]?.modelName 
            },
            //frequency
            schedule: {
              value: configurationDetails?.frequency?.value,
              unit: configurationDetails?.frequency?.unit
            },
            //threshold
            conditions: [{
              value: configurationDetails?.threshold?.value,
              condition: configurationDetails?.threshold?.condition,
              config: {
                type: configurationDetails?.threshold?.config?.type,
                min: configurationDetails?.threshold?.config?.min,
                max: configurationDetails?.threshold?.config?.max
              }
            }],
            impactedKpis:impactedKpis,
            assetList: selectedAssets,
          },
          modelParameters: timeseries,
        }
      ]
  }

  return ewbBody;
  }
}
